import React, {Component} from "react";
import ReactDOM from "react-dom";
import {KEYCODES} from "../utils/constants";

export interface CloseableProps {
  onClickOutside?: (e: MouseEvent) => void;
  onEscape?: () => void;
}

/**
 * Wrapper for elements that should close on escape or when a user clicks outside of the wrapped component
 */
export default class Closeable extends Component<CloseableProps> {
  constructor(props: CloseableProps) {
    super(props);

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    document.addEventListener('keydown', this.handleKeyDown, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    document.removeEventListener('keydown', this.handleKeyDown, true);
  }

  handleClickOutside(event: MouseEvent) {
    const domNode = ReactDOM.findDOMNode(this);

    if (!domNode || !domNode.contains(event.target as any)) {
      this.setState({
        visible : false
      });

      if (this.props.onClickOutside) {
        this.props.onClickOutside(event);
      }
    }
  }

  handleKeyDown(e: KeyboardEvent) {
    if (e.which === KEYCODES.ESCAPE) {
      this.setState({
        visible : false
      });

      if (this.props.onEscape) {
        this.props.onEscape();
      }
    }
  }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    )
  }
}
